import axios from 'axios'
import globalAxios from 'axios'
import router from './../../../router'

const namespaced = true;

const state = {
  account: {
    company: null,
    paymentMethodName: null,
    balance: 0.00,
    status: null,
  },
  cards: [],
  transactions: [],
};

const getters = {

  getAccount (state) {
    return state.account
  },

  getCompany (state) {
    return state.account.company
  },

};

const mutations = {
  setAccount (state, payload) {
    state.account = payload
  },

};


const actions = {

  fetchAccount ({commit, dispatch}, accountID) {
    return new Promise((resolve, reject) => {
      axios.get('/api/accounts/account/' + accountID)
        .then(res => {
          commit('setAccount', res.data.data)
          console.log('fetchAccount - Account details fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

};


export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/security/account.js